import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/sysConfig',
  title: window.language['menu.sysConfig.config'],
  component: dynamicWrapper(app, [import('./model'),import('../../Material/Material/model'),import('../../HomePage/model'),], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/System/SysConfig/index.js